import { CountOperator } from '@reach/shared-types/conditions';
import { Trash2 } from 'lucide-react';
import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

const COUNT_OPERATOR_OPTIONS: { value: CountOperator; label: string }[] = [
  { value: CountOperator.EQ, label: 'exactly' },
  { value: CountOperator.GT, label: 'more than' },
  { value: CountOperator.GTE, label: 'at least' },
  { value: CountOperator.LT, label: 'fewer than' },
  { value: CountOperator.LTE, label: 'at most' },
];

interface RecordCountRowProps {
  countOperator: CountOperator;
  countValue: number;
  onChange: (count: { countOperator: CountOperator; countValue: number }) => void;
  onRemove: () => void;
  disabled?: boolean;
  readOnly?: boolean;
}

export const RecordCountRow: React.FC<RecordCountRowProps> = ({
  countOperator,
  countValue,
  onChange,
  onRemove,
  disabled = false,
  readOnly = false,
}) => {
  const inputsDisabled = disabled || readOnly;
  const handleOperatorChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ countOperator: e.target.value as CountOperator, countValue });
  };

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsedValue = parseInt(e.target.value, 10);
    const isWholeNonNegative = !Number.isNaN(parsedValue) && parsedValue >= 0;
    if (isWholeNonNegative) {
      onChange({ countOperator, countValue: parsedValue });
    }
  };

  return (
    <div className={styles.measureRow}>
      <span className={styles.subjectPhrase}>number of records</span>
      <select
        className={styles.measureSelect}
        value={countOperator}
        onChange={handleOperatorChange}
        disabled={inputsDisabled}
        aria-label="Count operator">
        {COUNT_OPERATOR_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <input
        type="number"
        min={0}
        value={countValue}
        onChange={handleValueChange}
        disabled={inputsDisabled}
        className={styles.measureNumberInput}
        aria-label="Count value"
      />
      {!readOnly && (
        <button
          type="button"
          className={styles.relatedTitleButton}
          onClick={onRemove}
          disabled={inputsDisabled}
          aria-label="Remove record count">
          <Trash2 size={15} />
        </button>
      )}
    </div>
  );
};
